/**
 * Contact Form Handler
 * Handles form submission and opens email client with form data
 */

function initContactForm() {
  const contactForm = document.querySelector('.contact-form');

  if (!contactForm) {
    return;
  }

  contactForm.addEventListener('submit', async function (e) {
    e.preventDefault();

    // Clear previous error messages
    clearEmailError();

    // Get form data
    const formData = new FormData(contactForm);
    const firstName = formData.get('firstName') || '';
    const lastName = formData.get('lastName') || '';
    const email = formData.get('email') || '';
    const message = formData.get('message') || '';

    // Validate required fields
    let isValid = true;

    if (!firstName.trim()) {
      const firstNameInput = contactForm.querySelector('#firstName');
      if (firstNameInput) {
        firstNameInput.classList.add('form-control--invalid');
      }
      isValid = false;
    }

    if (!lastName.trim()) {
      const lastNameInput = contactForm.querySelector('#lastName');
      if (lastNameInput) {
        lastNameInput.classList.add('form-control--invalid');
      }
      isValid = false;
    }

    if (!email.trim()) {
      showEmailError('Incorrect email');
      isValid = false;
    } else {
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        showEmailError('Incorrect email');
        isValid = false;
      }
    }

    if (!isValid) {
      // Scroll to first error field
      const firstErrorField = contactForm.querySelector('.form-control--invalid');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorField.focus();
      }
      return;
    }

    // Disable submit button to prevent double submission
    const submitButton = contactForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Sending...';

    // Prepare email content
    const subject = 'Contact Form Submission - ElectHQ Platform';
    const body = `
Hello ElectHQ Team,

You have received a new contact form submission:

Contact Information:
- Name: ${firstName} ${lastName}
- Email: ${email}
${message ? `- Message: ${message}` : ''}

Please contact the user to follow up.

Best regards,
ElectHQ Platform
    `.trim();

    // Send email directly to contact email from env
    const contactEmail = window.CONTACT_EMAIL || 'info@vanguardai.net';
    
    try {
      const res_email = await fetch(`${API_BASE_URL}/api/send-mail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: contactEmail,
          subject: subject,
          content: body
        })
      });

      if (!res_email.ok) {
        const errorData = await res_email.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to send email');
      }

      // Reset form
      contactForm.reset();
      
      // Reset character counter
      const messageTextarea = contactForm.querySelector('#message');
      const charCounter = contactForm.querySelector('.char-counter');
      if (messageTextarea && charCounter) {
        charCounter.textContent = '0/1000';
      }

      // Show success message
      showFormSuccessMessage(contactForm);

    } catch (error) {
      console.error('Error sending email:', error);
      
      // Re-enable submit button
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
      
      // Get API base URL for debug info
      const apiBaseUrl = typeof API_BASE_URL !== 'undefined' ? API_BASE_URL : (window.API_BASE_URL || 'https://api.electhq.net');
      
      // Use shared error modal utility
      if (typeof window.showErrorModal === 'function') {
        await window.showErrorModal(error, `${apiBaseUrl}/api/send-mail`, {
          title: 'Send Email Error',
          message: 'An error occurred while sending your message. Please try again.',
          additionalInfo: {
            formType: 'contact-form-send-email',
            email: email,
          },
        });
      } else {
        // Fallback if utility not loaded
        alert('An error occurred while sending your message. Please try again.');
      }
    } finally {
      // Re-enable submit button in case of any error
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }

  });
}

function initVerificationForm() {
  const verificationForm = document.querySelector('.verification-form');
  const contactForm = document.querySelector('.contact-form');

  if (!verificationForm) {
    return;
  }

  verificationForm.addEventListener('submit', async function (e) {
    e.preventDefault();

    // Get form data
    const verificationCode = verificationForm.querySelector('#verificationCode').value || '';

    // Get form data
    const formData = new FormData(contactForm);
    const firstName = formData.get('firstName') || '';
    const lastName = formData.get('lastName') || '';
    const email = formData.get('email') || '';
    const message = formData.get('message') || '';

    // Validate required fields
    if (!verificationCode.trim()) {
      alert('Please enter the verification code.');
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/candidate_profiles/questions/verify-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code: verificationCode }),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        const errorMessage = errorData?.message || 'Failed to verify code. Please try again.';
        alert(errorMessage);
        const codeInput = verificationForm.querySelector('#verificationCode');
        if (codeInput) {
          codeInput.classList.add('form-control--invalid');
        }
        return;
      }

      // Prepare email content
      const subject = 'Demo Request - ElectHQ Platform';
      const body = `
      Hello ElectHQ Team,

      I would like to request a demo of your election platform.

      Contact Information:
      - Name: ${firstName} ${lastName}
      - Email: ${email}
      ${message ? `- Message: ${message}` : ''}

      Please contact me to schedule a demo session.

      Best regards,
      ${firstName} ${lastName}
    `.trim();

      try {
        const res_email = await fetch(`${API_BASE_URL}/api/send-mail`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: 'info@vanguardai.net',
            subject: subject,
            content: body
          })
        });
        console.log('res_email', res_email);

        if (!res_email.ok) {
          throw new Error('Failed to send email');
        }
      } catch (emailError) {
        console.error('Error sending email:', emailError);
        
        // Get API base URL for debug info
        const apiBaseUrl = typeof API_BASE_URL !== 'undefined' ? API_BASE_URL : (window.API_BASE_URL || 'https://api.electhq.net');
        
        // Use shared error modal utility
        if (typeof window.showErrorModal === 'function') {
          await window.showErrorModal(emailError, `${apiBaseUrl}/api/send-mail`, {
            title: 'Send Email Error',
            message: 'Code verified but failed to send email. Please contact support.',
            additionalInfo: {
              formType: 'contact-form-send-email',
              email: email,
            },
          });
        }
        return;
      }

      // Close modal
      document.getElementById('verificationModal').style.display = 'none';

      // Reset form and modal input
      // document.querySelector('.contact-form').reset();
      // codeInput.value = '';
      // codeInput.classList.remove('form-control--invalid');

      // reset verification code input
      verificationForm.querySelector('#verificationCode').value = '';
      verificationForm.querySelector('#verificationCode').classList.remove('form-control--invalid');

      document.querySelector('.verification-input-group').style.display = 'none';

      // Show success message
      showFormSuccessMessage(contactForm);
    } catch (error) {
      console.error('Verification error:', error);
      
      // Get API base URL for debug info
      const apiBaseUrl = typeof API_BASE_URL !== 'undefined' ? API_BASE_URL : (window.API_BASE_URL || 'https://api.electhq.net');
      
      // Use shared error modal utility
      if (typeof window.showErrorModal === 'function') {
        await window.showErrorModal(error, `${apiBaseUrl}/candidate_profiles/questions/verify-code`, {
          title: 'Verification Error',
          message: 'An error occurred during verification. Please try again.',
          additionalInfo: {
            formType: 'contact-form-verify-code',
            email: email,
          },
        });
      } else {
        // Fallback if utility not loaded
        alert('An error occurred during verification. Please try again.');
      }
    }

  });
}

/**
 * Show success message after form submission
 */
function showFormSuccessMessage(form) {
  // Create success message element
  const successMessage = document.createElement('div');
  successMessage.className = 'form-success-message';
  successMessage.innerHTML = `
    <div class="success-content">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22,4 12,14.01 9,11.01"></polyline>
      </svg>
      <h3>Thank you for your interest in our platform!</h3>
      <p>Our expert will contact you to schedule a demo.</p>
    </div>
  `;

  // Insert after form
  form.parentNode.insertBefore(successMessage, form.nextSibling);

  // Hide form
  form.style.display = 'none';
  setTimeout(() => {
    successMessage.remove();
    form.style.display = 'block';
    form.reset();
  }, 3000);

  // Add CSS for success message
  const style = document.createElement('style');
  style.textContent = `
    .form-success-message {
      background: #f8f9fa;
      border: 2px solid #28a745;
      border-radius: 12px;
      padding: 30px;
      text-align: center;
      margin-top: 20px;
      animation: fadeInUp 0.6s ease-out;
    }
    
    .success-content svg {
      margin-bottom: 16px;
    }
    
    .success-content h3 {
      color: #28a745;
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 12px;
    }
    
    .success-content p {
      color: #6c757d;
      font-size: 16px;
      line-height: 1.6;
      margin: 0;
    }
    
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;

  document.head.appendChild(style);

  // Scroll to success message
  successMessage.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
}

/**
 * Initialize contact form validation styling
 */
function initContactFormValidation() {
  const form = document.querySelector('.contact-form');
  if (!form) return;

  const inputs = form.querySelectorAll('input[required]');

  inputs.forEach(input => {
    input.addEventListener('blur', function () {
      validateField(this);
    });

    input.addEventListener('input', function () {
      // Remove error styling and messages on input
      this.classList.remove('form-control--invalid');
      if (this.name === 'email') {
        clearEmailError();
      } else {
        clearFieldError(this);
      }
    });
  });
  
  // Also validate email field even if it loses focus without being required initially
  const emailInput = form.querySelector('#email');
  if (emailInput) {
    emailInput.addEventListener('blur', function () {
      validateField(this);
    });
    
    emailInput.addEventListener('input', function () {
      this.classList.remove('form-control--invalid');
      clearEmailError();
    });
  }

  // Handle firstName field
  const firstNameInput = form.querySelector('#firstName');
  if (firstNameInput) {
    firstNameInput.addEventListener('blur', function () {
      validateField(this);
    });
    
    firstNameInput.addEventListener('input', function () {
      this.classList.remove('form-control--invalid');
      clearFieldError(this);
    });
  }
  
  // Handle lastName field
  const lastNameInput = form.querySelector('#lastName');
  if (lastNameInput) {
    lastNameInput.addEventListener('blur', function () {
      validateField(this);
    });
    
    lastNameInput.addEventListener('input', function () {
      this.classList.remove('form-control--invalid');
      clearFieldError(this);
    });
  }

  // Initialize character counter for message textarea
  const messageTextarea = form.querySelector('#message');
  const charCounter = form.querySelector('.char-counter');
  
  if (messageTextarea && charCounter) {
    // Update counter on input
    messageTextarea.addEventListener('input', function () {
      const currentLength = this.value.length;
      const maxLength = this.getAttribute('maxlength') || 1000;
      charCounter.textContent = `${currentLength}/${maxLength}`;
    });

    // Initialize counter on page load
    const initialLength = messageTextarea.value.length;
    const maxLength = messageTextarea.getAttribute('maxlength') || 1000;
    charCounter.textContent = `${initialLength}/${maxLength}`;
  }

  // Handle required asterisk positioning - place it right after placeholder text
  const requiredInputs = form.querySelectorAll('input[required]');
  
  function updateAsteriskPosition(input, asterisk) {
    if (!input || !asterisk) return;
    
    const placeholder = input.getAttribute('placeholder') || '';
    if (!placeholder) return;
    
    // Create a temporary span to measure placeholder text width
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.style.fontSize = window.getComputedStyle(input).fontSize;
    tempSpan.style.fontWeight = window.getComputedStyle(input).fontWeight;
    tempSpan.style.fontFamily = window.getComputedStyle(input).fontFamily;
    tempSpan.textContent = placeholder;
    document.body.appendChild(tempSpan);
    
    const placeholderWidth = tempSpan.offsetWidth;
    document.body.removeChild(tempSpan);
    
    // Get input padding and icon offset
    const inputPaddingLeft = parseInt(window.getComputedStyle(input).paddingLeft) || 20;
    const inputIcon = input.parentElement.querySelector('.input-icon');
    const iconOffset = inputIcon ? (inputIcon.offsetWidth + parseInt(window.getComputedStyle(inputIcon).left) || 0) : 0;
    
    // Calculate position: padding left + icon width + placeholder width + small gap
    const leftPosition = inputPaddingLeft + iconOffset + placeholderWidth + 10;
    asterisk.style.left = `${leftPosition}px`;
  }
  
  requiredInputs.forEach(input => {
    const asterisk = input.parentElement.querySelector('.required-asterisk-inline');
    if (asterisk) {
      // Calculate initial position
      updateAsteriskPosition(input, asterisk);
      
      // Show/hide based on input value
      function updateAsteriskVisibility() {
        if (input.value) {
          asterisk.classList.remove('visible');
        } else {
          asterisk.classList.add('visible');
          // Recalculate position when showing
          updateAsteriskPosition(input, asterisk);
        }
      }
      
      // Initial state
      updateAsteriskVisibility();
      
      // Update on input
      input.addEventListener('input', updateAsteriskVisibility);
      
      // Update position on focus/blur (placeholder may hide/show)
      input.addEventListener('focus', function() {
        if (!this.value) {
          // Keep asterisk visible when focused but empty
          asterisk.classList.add('visible');
          updateAsteriskPosition(input, asterisk);
        }
      });
      
      input.addEventListener('blur', function() {
        if (!this.value) {
          asterisk.classList.add('visible');
          updateAsteriskPosition(input, asterisk);
        }
      });
      
      // Recalculate on window resize
      window.addEventListener('resize', () => {
        if (!input.value) {
          updateAsteriskPosition(input, asterisk);
        }
      });
    }
  });
}

/**
 * Validate individual form field
 */
function validateField(field) {
  const value = field.value.trim();
  const fieldName = field.name;

  // Clear previous error styling and messages
  field.classList.remove('form-control--invalid');
  if (fieldName === 'email') {
    clearEmailError();
  } else {
    clearFieldError(field);
  }

  // Validate based on field type
  if (fieldName === 'email' && value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      field.classList.add('form-control--invalid');
      showEmailError('Incorrect email');
      return false;
    }
  }

  if (field.hasAttribute('required') && !value) {
    field.classList.add('form-control--invalid');
    if (fieldName === 'email') {
      showEmailError('Incorrect email');
    }
    return false;
  }

  return true;
}

/**
 * Show email error message
 */
function showEmailError(message) {
  const emailInput = document.getElementById('email');
  const emailError = document.getElementById('emailError');
  
  if (emailInput) {
    emailInput.classList.add('form-control--invalid');
  }
  
  if (emailError) {
    emailError.textContent = message;
    emailError.style.display = 'block';
    emailError.style.color = '#DC2626'; // Ensure red color
  }
}

/**
 * Clear email error message
 */
function clearEmailError() {
  const emailInput = document.getElementById('email');
  const emailError = document.getElementById('emailError');
  
  if (emailInput) {
    emailInput.classList.remove('form-control--invalid');
  }
  
  if (emailError) {
    emailError.style.display = 'none';
    emailError.textContent = '';
  }
}

/**
 * Show field error styling
 */
function showFieldError(field, message) {
  if (field) {
    field.classList.add('form-control--invalid');
    
    // Show error message if error element exists
    const fieldName = field.name;
    const errorElement = document.getElementById(`${fieldName}Error`);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
      errorElement.style.color = '#DC2626'; // Ensure red color
    }
  }
}

/**
 * Clear field error
 */
function clearFieldError(field) {
  if (field) {
    field.classList.remove('form-control--invalid');
    
    const fieldName = field.name;
    const errorElement = document.getElementById(`${fieldName}Error`);
    if (errorElement) {
      errorElement.style.display = 'none';
      errorElement.textContent = '';
    }
  }
}

const closeModalBtn = document.getElementById('closeModal');
if (closeModalBtn) {
  closeModalBtn.onclick = function () {
    document.getElementById('verificationModal').style.display = 'none';
  };
}

const cancelButton = document.getElementById('cancelButton');
if (cancelButton) {
  cancelButton.onclick = function () {
    document.getElementById('verificationModal').style.display = 'none';
  };
}

window.onclick = function (event) {
  var modal = document.getElementById('verificationModal');
  if (event.target == modal) {
    modal.style.display = 'none';
  }
};

// Expose functions to global scope
window.initContactForm = initContactForm;
window.initContactFormValidation = initContactFormValidation;
window.initVerificationForm = initVerificationForm;